<script setup lang="ts">
defineOptions({
  name: 'MopJobFiltersOverlay',
});

const { $urls, $mopI18n } = useNuxtApp();
const route = useRoute();
const router = useRouter();
const { closeAll } = useMopOverlay();
const { getFilteredJobList } = useMopJob();
const countRef = ref(0);

async function handleClearAll() {
  let url = $mopI18n.localePath(`${$urls.CAREER_PAGE}`);
  if (route.query?.search) {
    url = $mopI18n.localePath(`${$urls.CAREER_PAGE}?search=${route.query.search}`);
  }
  await router.push(url);
  await closeAll();
}

function calculateTotals() {
  countRef.value = getFilteredJobList(route.query.search as string)?.length || 0;
}

onMounted(() => {
  calculateTotals();
  watch(() => route.fullPath, calculateTotals);
});
</script>

<template>
  <div class="job-filters-overlay">
    <MopJobFilters :count="countRef" />

    <div class="job-filters-overlay__actions">
      <button class="job-filters-overlay__action-clear" @click="handleClearAll">
        {{ $mopI18n.t('locale.jobs.clear_all_filters') }}
      </button>
      <button class="job-filters-overlay__action-apply" @click="closeAll">
        {{ $mopI18n.t('locale.jobs.apply_filters') }}
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.job-filters-overlay {
  padding: 0 $global-padding;

  &:deep(.job-filter__headline) {
    font-size: 16px;
  }
}

.job-filters-overlay__actions {
  display: flex;
  padding: $space20 0;
}

.job-filters-overlay__action-clear {
  @include text-style(strong);

  background: $white;
  color: $black;
  text-transform: uppercase;
  padding: 6px $space10;
  border: 1px solid $black;
  flex-grow: 1;
  margin-right: $space5;
}

.job-filters-overlay__action-apply {
  @include text-style(strong);

  background: $black;
  color: $white;
  text-transform: uppercase;
  padding: 6px $space10;
  border: 1px solid $black;
  flex-grow: 1;
  margin-left: $space5;
}
</style>
